import {createSlice} from '@reduxjs/toolkit';

const loaderSlice = createSlice({
  name: 'loader',
  initialState: {
    isLoading: false,
    isOverlay: true,
  },

  reducers: {
    showAppLoader: {
      reducer(state, action) {
        state.isLoading = true;
      },
    },
    hideAppLoader: {
      reducer(state, action) {
        state.isLoading = false;
      },
    },

    showOverlay: {
      reducer(state, action) {
        if (action.payload === false) {
          state.isOverlay = false;
        }
      },
    },
  },
});

export const {showAppLoader, hideAppLoader, showOverlay} = loaderSlice.actions;

export default loaderSlice.reducer;
